"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageLayerBuilder = exports.TextLayerBuilder = void 0;
var image_layer_1 = require("./layers/image.layer");
var text_layer_1 = require("./layers/text.layer");
var types_1 = require("./types");
var BaseBuilder = /** @class */ (function () {
    function BaseBuilder() {
    }
    BaseBuilder.prototype.withPosition = function (x, y) {
        this.layer.x = x;
        this.layer.y = y;
        return this;
    };
    BaseBuilder.prototype.withRotation = function (rotation) {
        this.layer.rotation = rotation;
        return this;
    };
    BaseBuilder.prototype.withSize = function (height, width) {
        this.layer.height = height;
        this.layer.width = width || height;
        return this;
    };
    BaseBuilder.prototype.withTag = function (tag) {
        this.layer.tag = tag;
        return this;
    };
    BaseBuilder.prototype.asCentered = function () {
        this.layer.verticalAlignment = types_1.VerticalAlignmentType.CENTER;
        this.layer.horizontalAlignment = types_1.HorizontalAlignmentType.CENTER;
        this.layer.stretching = types_1.StretchingType.CENTER;
        return this;
    };
    BaseBuilder.prototype.withAlignment = function (horizontalAlignment, verticalAlignment) {
        this.layer.horizontalAlignment =
            horizontalAlignment.toLowerCase();
        this.layer.verticalAlignment =
            verticalAlignment.toLowerCase();
        this.layer.stretching = types_1.StretchingType.CENTER;
        return this;
    };
    BaseBuilder.prototype.leftAligned = function () {
        this.layer.horizontalAlignment = types_1.HorizontalAlignmentType.LEFT;
        this.layer.stretching = types_1.StretchingType.CENTER;
        return this;
    };
    BaseBuilder.prototype.rightAligned = function () {
        this.layer.horizontalAlignment = types_1.HorizontalAlignmentType.RIGHT;
        this.layer.stretching = types_1.StretchingType.CENTER;
        return this;
    };
    BaseBuilder.prototype.topAligned = function () {
        this.layer.verticalAlignment = types_1.VerticalAlignmentType.TOP;
        this.layer.stretching = types_1.StretchingType.CENTER;
        return this;
    };
    BaseBuilder.prototype.bottomAligned = function () {
        this.layer.verticalAlignment = types_1.VerticalAlignmentType.BOTTOM;
        this.layer.stretching = types_1.StretchingType.CENTER;
        return this;
    };
    BaseBuilder.prototype.withZ = function (z) {
        this.layer.z = z;
        return this;
    };
    BaseBuilder.prototype.withStyle = function (style) {
        this.layer.style = style;
        return this;
    };
    BaseBuilder.prototype.build = function () {
        return this.layer;
    };
    return BaseBuilder;
}());
var TextLayerBuilder = /** @class */ (function (_super) {
    __extends(TextLayerBuilder, _super);
    function TextLayerBuilder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.layer = new text_layer_1.TextLayer();
        return _this;
    }
    TextLayerBuilder.prototype.withText = function (text) {
        this.layer.text = text;
        return this;
    };
    TextLayerBuilder.prototype.asHtml = function () {
        this.layer.renderAsHtml = true;
        return this;
    };
    return TextLayerBuilder;
}(BaseBuilder));
exports.TextLayerBuilder = TextLayerBuilder;
var ImageLayerBuilder = /** @class */ (function (_super) {
    __extends(ImageLayerBuilder, _super);
    function ImageLayerBuilder() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.layer = new image_layer_1.ImageLayer();
        return _this;
    }
    ImageLayerBuilder.prototype.withImageId = function (id) {
        this.layer.imageId = id;
        return this;
    };
    return ImageLayerBuilder;
}(BaseBuilder));
exports.ImageLayerBuilder = ImageLayerBuilder;
